import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["display"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system, { getDisplay } from '../../system';
import Base from '../Base';
var SYSTEM_PROPS = ['backgroundProps', 'borderProps', 'borderRadiusProps', 'colorProps', 'flexParentProps', 'flexProps', 'floatProps', 'heightProps', 'marginProps', 'paddingProps', 'positioningProps', 'textProps', 'widthProps'];
var Flex = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var display = _ref.display,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  var displayFlexClassName = getDisplay(display);
  return /*#__PURE__*/React.createElement(Base, _extends({
    ref: ref,
    className: cx(displayFlexClassName, className),
    style: style
  }, rest));
});
Flex.displayName = 'Flex';
Flex.identifier = Flex.displayName;
Flex.clonableProps = SYSTEM_PROPS;
Flex.defaultProps = {
  display: 'flex'
};
export default Flex;